export const orgConstants = {
  ORG_SET_CURRENT_ORG_ID: "ORG_SET_CURRENT_ORG_ID",

  ORG_GETLIST_REQUEST: "ORG_GETLIST_REQUEST",
  ORG_GETLIST_SUCCESS: "ORG_GETLIST_SUCCESS",
  ORG_GETLIST_FAILURE: "ORG_GETLIST_FAILURE",

  ORG_CREATE_REQUEST: "ORG_CREATE_REQUEST",
  ORG_CREATE_SUCCESS: "ORG_CREATE_SUCCESS",
  ORG_CREATE_FAILURE: "ORG_CREATE_FAILURE",
  ORG_CREATE_RESET: "ORG_CREATE_RESET",

  ORG_EDIT_REQUEST: "ORG_EDIT_REQUEST",
  ORG_EDIT_SUCCESS: "ORG_EDIT_SUCCESS",
  ORG_EDIT_FAILURE: "ORG_EDIT_FAILURE",
  ORG_EDIT_RESET: "ORG_EDIT_RESET",

  ORG_ORGTYPES_REQUEST: "ORG_ORGTYPES_REQUEST",
  ORG_ORGTYPES_SUCCESS: "ORG_ORGTYPES_SUCCESS",
  ORG_ORGTYPES_FAILURE: "ORG_ORGTYPES_FAILURE",

  ORG_INGESTION_STATS_REQUEST: "ORG_INGESTION_STATS_REQUEST",
  ORG_INGESTION_STATS_SUCCESS: "ORG_INGESTION_STATS_SUCCESS",
  ORG_INGESTION_STATS_FAILURE: "ORG_INGESTION_STATS_FAILURE",
  ORG_INGESTION_STATS_CLEAR: "ORG_INGESTION_STATS_CLEAR",

  ORG_SCRAPE_INFO_REQUEST: "ORG_SCRAPE_INFO_REQUEST",
  ORG_SCRAPE_INFO_SUCCESS: "ORG_SCRAPE_INFO_SUCCESS",
  ORG_SCRAPE_INFO_FAILURE: "ORG_SCRAPE_INFO_FAILURE",

  ORG_OCR_INFO_REQUEST: "ORG_OCR_INFO_REQUEST",
  ORG_OCR_INFO_SUCCESS: "ORG_OCR_INFO_SUCCESS",
  ORG_OCR_INFO_FAILURE: "ORG_OCR_INFO_FAILURE",

  ORG_GET_ORG_LIST_REQUEST: "ORG_GET_ORG_LIST_REQUEST",
  ORG_GET_ORG_LIST_SUCCESS: "ORG_GET_ORG_LIST_SUCCESS",
  ORG_GET_ORG_LIST_FAILURE: "ORG_GET_ORG_LIST_FAILURE",

  ORG_GET_ORG_DETAIL_REQUEST: "ORG_GET_ORG_DETAIL_REQUEST",
  ORG_GET_ORG_DETAIL_SUCCESS: "ORG_GET_ORG_DETAIL_SUCCESS",
  ORG_GET_ORG_DETAIL_FAILURE: "ORG_GET_ORG_DETAIL_FAILURE",

  ORG_GET_ORG_USERS_REQUEST: "ORG_GET_ORG_USERS_REQUEST",
  ORG_GET_ORG_USERS_SUCCESS: "ORG_GET_ORG_USERS_SUCCESS",
  ORG_GET_ORG_USERS_FAILURE: "ORG_GET_ORG_USERS_FAILURE",

  ORG_GET_DOC_TYPES_REQUEST: "ORG_GET_DOC_TYPES_REQUEST",
  ORG_GET_DOC_TYPES_SUCCESS: "ORG_GET_DOC_TYPES_SUCCESS",
  ORG_GET_DOC_TYPES_FAILURE: "ORG_GET_DOC_TYPES_FAILURE",

  ORG_CREATE_DOCTYPE_REQUEST: "ORG_CREATE_DOCTYPE_REQUEST",
  ORG_CREATE_DOCTYPE_SUCCESS: "ORG_CREATE_DOCTYPE_SUCCESS",
  ORG_CREATE_DOCTYPE_FAILURE: "ORG_CREATE_DOCTYPE_FAILURE",
  ORG_CREATE_DOCTYPE_RESET: "ORG_CREATE_DOCTYPE_RESET",

  ORG_EDIT_DOCTYPE_REQUEST: "ORG_EDIT_DOCTYPE_REQUEST",
  ORG_EDIT_DOCTYPE_SUCCESS: "ORG_EDIT_DOCTYPE_SUCCESS",
  ORG_EDIT_DOCTYPE_FAILURE: "ORG_EDIT_DOCTYPE_FAILURE",
  ORG_EDIT_DOCTYPE_RESET: "ORG_EDIT_DOCTYPE_RESET",  

  ORG_DELETE_DOCTYPE_REQUEST: "ORG_DELETE_DOCTYPE_REQUEST",
  ORG_DELETE_DOCTYPE_SUCCESS: "ORG_DELETE_DOCTYPE_SUCCESS",
  ORG_DELETE_DOCTYPE_FAILURE: "ORG_DELETE_DOCTYPE_FAILURE",
  ORG_DELETE_DOCTYPE_RESET: "ORG_DELETE_DOCTYPE_RESET",  

};
